module.exports = __webpack_public_path__ + "img/icon-locale.ed6da093.svg";